// extracted by mini-css-extract-plugin
export default {"containerTelaInicial":"TelaInicial_containerTelaInicial__f-ibF","caixa1":"TelaInicial_caixa1__T2cWD","botao":"TelaInicial_botao__wcWYN","caixa2":"TelaInicial_caixa2__8Yx8N"};